import { alpha, Box, Button, Chip, CircularProgress, Typography } from '@mui/material';
import { BubbleChart as BubbleChartIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { C } from './shared';

export default function PageHeader({ t, summary, loading, marketBiasMeta, onRefresh }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, flex: '1 1 420px' }}>
        <Box sx={{ width: 42, height: 42, borderRadius: 1.5, background: `linear-gradient(135deg, ${C.bottoming} 0%, ${C.acceleration} 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: `0 4px 14px ${alpha(C.bottoming, 0.3)}`, flexShrink: 0 }}>
          <BubbleChartIcon sx={{ color: '#fff', fontSize: 22 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography sx={{ fontSize: '1.35rem', fontWeight: 800, color: C.ink, letterSpacing: -0.3 }}>
              {t('bottomingFlow.title')}
            </Typography>
            {summary?.score_date && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, bgcolor: '#f1f5f9', px: 1, py: 0.3, borderRadius: 1 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: C.bottoming, boxShadow: `0 0 6px ${C.bottoming}` }} />
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: C.inkMid }}>{summary.score_date}</Typography>
              </Box>
            )}
            <Chip size="small" label={marketBiasMeta.label} sx={{ height: 22, fontSize: '0.66rem', fontWeight: 800, color: marketBiasMeta.color, bgcolor: alpha(marketBiasMeta.color, 0.09) }} />
          </Box>
          <Typography sx={{ fontSize: '0.75rem', color: C.inkSoft, fontWeight: 500 }}>
            {t('bottomingFlow.subtitle')}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end', flex: '0 0 auto', ml: 'auto' }}>
        <Button
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon sx={{ fontSize: 16 }} />}
          disabled={loading}
          onClick={onRefresh}
          sx={{ textTransform: 'none', fontSize: 13, fontWeight: 600, borderRadius: '4px', bgcolor: C.acceleration, color: '#fff', px: 2, height: 32, '&:hover': { bgcolor: '#2563eb' }, '&:disabled': { bgcolor: '#94a3b8', color: '#fff' } }}
        >
          {loading ? t('bottomingFlow.actions.loading') : t('bottomingFlow.actions.refresh')}
        </Button>
      </Box>
    </Box>
  );
}
